import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { SponsorEntity, StrapiMedia, ElementImage } from "../types/strapi";
import { siteUrl } from "../utils/constants";

interface TestimonialProps {
  sponsors: SponsorEntity;
}

const Testimonial = ({ sponsors }: TestimonialProps) => (
  <div className="rn-testimonial-area bg_color--5 ptb--120">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="section-title text-center mb--25">
            <span className="subtitle">
              {sponsors?.superHeadingTwo ?? ""}
            </span>
            <h3 className="title mb--50">
              {sponsors?.headingTwo ?? ""}
            </h3>
          </div>
          <Tabs>
            <div className="row align-items-center">
              <div className="col-lg-6 mt_md--40 mt_sm--40">
                <TabList className="testimonial-thumb-wrapper">
                  {sponsors?.sponsors ? (
                    sponsors.sponsors.map(
                      (sponsor: StrapiMedia, index: number) => (
                        <Tab key={`tab${index}`}>
                          <div className="testimonial-thumbnai">
                            <div className="thumb">
                              {sponsor ? (
                                <img
                                  src={
                                    siteUrl +
                                    sponsor.formats?.thumbnail?.url
                                  }
                                  alt={`Cultural Ecologies sponsor no. ${index}`}
                                />
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </Tab>
                      )
                    )
                  ) : (
                    <Tab />
                  )}
                </TabList>
              </div>
              <div className="col-lg-6">
                {sponsors?.image &&
                sponsors.image.length > 0 ? (
                  sponsors.image.map(
                    (sponsor: ElementImage, index: number) => (
                      <TabPanel key={`tabPanel${index}`}>
                        <div className="rn-testimonial-content text-start">
                          <div>
                            {sponsor.caption
                              ?.split("\n\n")
                              ?.map((paragraph: string, subIndex: number) => (
                                <p
                                  className="sponsorship"
                                  key={`tabParagraph${subIndex}`}
                                >
                                  {paragraph}
                                </p>
                              ))}
                          </div>
                        </div>
                      </TabPanel>
                    )
                  )
                ) : (
                  <TabPanel />
                )}
              </div>
            </div>
          </Tabs>
        </div>
      </div>
    </div>
  </div>
);

export default Testimonial;
